<script>
import { MapAgentStationStatus, MapRefundStatus } from "@/common/util";
import basicLineChart from "@/components/visionStatistics/basicLineChart.vue";
import basicBarChart from "@/components/visionStatistics/basicBarChart.vue";

import sortBy from "lodash/sortBy";
import cloneDeep from "lodash/cloneDeep";
import forOwn from "lodash/forOwn";
import moment from "moment";
export default {
  components: {
    basicLineChart,
    basicBarChart
  },
  data() {
    const defaultDate = [
      moment()
        .subtract(1, "months")
        .format("YYYY-MM-DD"),
      moment().format("YYYY-MM-DD")
    ];
    const ROLE_STATION_MANAGER =
      localStorage.getItem("roles").indexOf("ROLE_STATION_MANAGER") > -1;

    return {
      dateRange: defaultDate,
      ROLE_STATION_MANAGER,
      chartArray: [],
      needRefresh: true,
      ProvinceList: [],
      provinceCity: undefined,
      achievementData: {
        remainingTreatmentCount: undefined,
        sales: undefined,
        targetCount: undefined
      },
      options: [
        {
          value: "YEAR",
          label: "年度"
        },
        {
          value: "QUARTER",
          label: "季度"
        },
        {
          value: "MONTH",
          label: "月度"
        }
      ],
      dateRangeValue: "MONTH",
      activeTab: "client",
      totalSales: {
        StatisticsResult: undefined,
        chartTitle: undefined,
        chartYTitle: undefined,
        yType: undefined,
        seriesNameY: undefined
      },
      dateRangeTotalSales: undefined,
      AgentSalesAndStation: {
        StatisticsResult: undefined,
        chartTitle: undefined,
        chartYTitle: undefined,
        yType: undefined,
        seriesNameY: undefined
      },
      stationList: [],
      stationId: undefined,
      activeStationName: undefined
    };
  },
  created() {
    if (!this.ROLE_STATION_MANAGER) {
      this.loadProvice();
      this.loadData();
    }

    this.loadSales();
    this.loadStatistic("client");
    this.loadStation();
  },
  methods: {
    async loadData() {
      const result = await this.$http.getAgentAchievementStatistic();
      if (result) {
        this.achievementData = result;
      }
    },
    async loadStation() {
      if (this.ROLE_STATION_MANAGER) {
        let stationList = await this.$http.getAgentStationList();
        const AgentStationList = [];
        stationList.forEach(o => {
          if (o.isDirector) {
            AgentStationList.push({
              value: o.stationUUID,
              label: o.name
            });
          }
        });
        this.stationList = AgentStationList;
      } else {
        const result = await this.$http.getMedicalEstablishmentList(
          { agentStationState: "APPROVED" },
          "ROLE_AGENT"
        );
        if (result) {
          this.stationList = result.map(o => {
            return {
              value: o.stationUUID,
              label: o.name
            };
          });
        }
      }
    },
    async loadProvice() {
      let ProvinceList = [];
      ProvinceList = await this.$http.getProvinceList("agent");
      if (ProvinceList.length > 0) {
        const provinceChildren = ProvinceList.map(o => {
          return {
            label: o.name,
            keyName: o.id,
            value: o.id,
            children: o.sons.map(o => {
              return {
                label: o.name,
                value: o.id
              };
            }),
            id: o.id,
            name: o.name
          };
        });
        this.ProvinceList = provinceChildren;
      }
    },
    onSearch() {
      this.loadStatistic(this.activeTab);
    },
    async loadStatistic(chartType) {
      const params = {};
      params.statisticType = this.dateRangeValue === "YEAR" ? "YEAR" : "MONTH";
      if (this.dateRangeValue !== "YEAR") {
        params.end = moment().format("YYYY-MM-DD");
        params.start = moment()
          .subtract(11, "month")
          .startOf("month")
          .format("YYYY-MM-DD");
      }

      if (this.provinceCity && this.provinceCity[0]) {
        params.provinceId = this.provinceCity[0];
      }
      if (this.provinceCity && this.provinceCity[1]) {
        params.cityId = this.provinceCity[1];
      }
      if (chartType === "client" && this.stationId) {
        params.stationUUID = this.stationId;
      }
      let result = [];
      if (this.stationId) {
        params.stationUUID = this.stationId;
        result = await this.$http.getStationSalesById(params);
      } else if (chartType === "station") {
        result = await this.$http.getAgentStatistic(params, "station");
      } else {
        result = await this.$http.getAgentStatistic(params);
      }
      if (this.dateRangeValue === "YEAR") {
        let AgentSalesAndStation = {
          chartTitle: undefined,
          chartYTitle: chartType === "client" ? "疗程个数" : "新增医疗机构个数",
          yType: "AgentSalesAndStation",
          seriesNameY: chartType === "client" ? "疗程销量" : "新增医疗机构",
          StatisticsX: [],
          StatisticsY: [],
          legend: []
        };
        if (chartType === "client") {
          if (this.stationId) {
            AgentSalesAndStation.legend = ["实际销售"];
          } else {
            AgentSalesAndStation.legend = ["实际销售", "销售目标"];
          }
        }

        const tempX = [];
        const tempY1 = [];
        const tempY2 = [];
        result.forEach(item => {
          tempX.push(`${moment(item.time).get("year")}年`);
          tempY1.push(item.count);
          tempY2.push(item.targetCount);
        });
        AgentSalesAndStation.StatisticsX.push(tempX);
        AgentSalesAndStation.StatisticsY.push(tempY1);
        if (chartType === "client") {
          AgentSalesAndStation.StatisticsY.push(tempY2);
        }
        this.AgentSalesAndStation = AgentSalesAndStation;
      } else if (this.dateRangeValue === "QUARTER") {
        const AgentSalesAndStation = {
          chartTitle: undefined,
          chartYTitle: chartType === "client" ? "疗程个数" : "新增医疗机构个数",
          yType: "AgentSalesAndStation",
          seriesNameY: chartType === "client" ? "疗程销量" : "新增医疗机构",
          StatisticsX: [],
          StatisticsY: [],
          legend: []
        };
        const tempX = [];
        const tempY1 = [];
        const mapQuarter = {};
        result.forEach(item => {
          const tempQuarter = `${moment(item.time).year()}年第${moment(
            item.time
          ).quarter()}季度`;
          if (mapQuarter[tempQuarter]) {
            mapQuarter[tempQuarter] = mapQuarter[tempQuarter] + item.count;
          } else {
            mapQuarter[tempQuarter] = item.count;
          }
        });
        for (let item in mapQuarter) {
          tempX.push(item);
          tempY1.push(mapQuarter[item]);
        }
        AgentSalesAndStation.StatisticsX.push(tempX);
        AgentSalesAndStation.StatisticsY.push(tempY1);
        this.AgentSalesAndStation = AgentSalesAndStation;
      } else {
        const AgentSalesAndStation = {
          chartTitle: undefined,
          chartYTitle: chartType === "client" ? "疗程个数" : "新增医疗机构个数",
          yType: "AgentSalesAndStation",
          seriesNameY: chartType === "client" ? "疗程销量" : "新增医疗机构",
          StatisticsX: [],
          StatisticsY: [],
          legend: []
        };
        const tempX = [];
        const tempY1 = [];
        result.forEach(item => {
          tempX.push(`${moment(item.time).get("month") + 1}月`);
          tempY1.push(item.count);
        });
        AgentSalesAndStation.StatisticsX.push(tempX);
        AgentSalesAndStation.StatisticsY.push(tempY1);
        this.AgentSalesAndStation = AgentSalesAndStation;
      }
      this.needRefresh = false;
      this.$nextTick(() => {
        this.needRefresh = true;
      });
    },
    async loadSales() {
      const params = {
        start: this.dateRange[0],
        end: this.dateRange[1]
      };
      const result = await this.$http.managerSalesStatistic(params);
      const totalSales = {
        chartTitle: undefined,
        chartYTitle: "销量",
        yType: "totalSales",
        seriesNameY: "累计销量",
        StatisticsResult: []
      };
      let total = 0;
      result.forEach(item => {
        total = total + item.count;
        totalSales.StatisticsResult.push({
          createdAt: item.time,
          value: total
        });
      });
      this.dateRangeTotalSales = total;
      this.totalSales = totalSales;
      this.needRefresh = false;
      this.$nextTick(() => {
        this.needRefresh = true;
      });
    },
    onSwitchTab(tabName) {
      this.activeTab = tabName;
      this.loadStatistic(tabName);
    },
    onDateChange() {
      this.loadSales();
    },
    onDateTypeChange() {
      this.loadStatistic(this.activeTab);
    },
    onClearData() {
      this.needRefresh = false;
      this.$nextTick(() => {
        this.needRefresh = true;
      });
    },
    onStationValueChange(value) {
      if (value) {
        this.activeStationName = this.stationList.filter(
          o => o.value === value
        )[0].label;
      } else {
        this.activeStationName = undefined;
      }
      this.onSwitchTab("client");
    }
  }
};
</script>
<template>
  <div class="StatisticsAgent">
    <div class="cardTitleText">区域统计图</div>
    <el-row :gutter="24" class="gameSearchForm">
      <el-col :span="24" class="colStyle">
        <div style="display:inline-block">
          <span class="searchTitle" v-if="!ROLE_STATION_MANAGER">省市搜索：</span>
          <span v-if="!ROLE_STATION_MANAGER">
            <el-cascader
              :options="ProvinceList"
              v-model="provinceCity"
              class="selectInputStyle"
              clearable
              filterable
              :props="{ checkStrictly: true, expandTrigger: 'hover' }"
            ></el-cascader>
          </span>
          <span class="searchTitle">医疗机构：</span>
          <span>
            <el-select
              v-model="stationId"
              placeholder="请选择"
              class="selectInputStyle"
              clearable
              @change="onStationValueChange"
              filterable
              @clear="onClearData('agent')"
            >
              <el-option
                v-for="item in stationList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </span>
          <el-button class="searchButton" size="medium" @click="onSearch">搜索</el-button>
        </div>
        <div class="searchLocation" v-if="!ROLE_STATION_MANAGER">
          <div>
            <div class="saleNumberTitle">业绩目标</div>
            <div
              class="saleNumber"
            >{{achievementData.sales || '--'}}/{{achievementData.targetCount || '--'}}疗程</div>
          </div>
          <div class="line"></div>
          <div>
            <div class="saleNumberTitle">剩余疗程/单次训练</div>
            <div class="saleNumber">{{achievementData.remainingTreatmentCount || '--'}}疗程/{{ achievementData.remainingSingleCount }}次</div>
          </div>
          <div>
            <el-tag
              v-if="achievementData.remainingTreatmentCount && achievementData.remainingTreatmentCount < 100"
              size="mini"
              type="danger"
            >即将售罄</el-tag>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="24" class="gameSearchForm">
      <el-col :span="12" class="colStyle">
        <span
          class="filterTab"
          :style="activeTab === 'client' ? { color: '#ffffff', 'background-color': '#00c1de'} : ''"
          @click="onSwitchTab('client')"
        >终端销量</span>
        <span
          class="filterTab"
          v-if="!stationId && !ROLE_STATION_MANAGER"
          :style="activeTab === 'station' ? { color: '#ffffff', 'background-color': '#00c1de'} : ''"
          @click="onSwitchTab('station')"
        >新增医疗机构</span>
      </el-col>
      <el-col :span="12" class="colStyle targetView">
        <div class="selectDateView">
          <el-select
            v-model="dateRangeValue"
            @change="onDateTypeChange"
            class="timeFilterSelect"
            placeholder="请选择"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
      </el-col>
    </el-row>
    <div v-if="activeStationName" class="dateSelectTitle">当前医疗机构：{{activeStationName}}</div>
    <div class="chartview" v-if="needRefresh">
      <basicBarChart
        v-if="AgentSalesAndStation.StatisticsX"
        class="statisticsCharts"
        :StatisticsX="AgentSalesAndStation.StatisticsX"
        :StatisticsY="AgentSalesAndStation.StatisticsY"
        :legend="AgentSalesAndStation.legend"
        :chartTitle="AgentSalesAndStation.chartTitle"
        :chartYTitle="AgentSalesAndStation.chartYTitle"
        :yType="AgentSalesAndStation.yType"
        :seriesNameY="AgentSalesAndStation.seriesNameY"
        width="100%"
      />
    </div>
    <el-row :gutter="24" class="gameSearchForm">
      <el-col :span="12" class="colStyle">
        <div class="dateSelectTitle">累计销量</div>
        <div>
          <el-date-picker
            v-model="dateRange"
            size="medium"
            class="dateRange"
            type="daterange"
            range-separator="至"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="onDateChange"
          ></el-date-picker>
        </div>
      </el-col>
      <el-col :span="12" class="colStyle targetView">
        <div class="searchLocation" style="margin-top: 0px">
          <div>
            <div class="saleNumberTitle">本期销量</div>
            <div class="saleNumber">{{dateRangeTotalSales || '--'}}疗程</div>
          </div>
        </div>
      </el-col>
    </el-row>
    <div class="chartview" v-if="needRefresh">
      <basicLineChart
        class="statisticsCharts"
        v-if="totalSales.StatisticsResult"
        :StatisticsResult="totalSales.StatisticsResult"
        :chartTitle="totalSales.chartTitle"
        :chartYTitle="totalSales.chartYTitle"
        :yType="totalSales.yType"
        :seriesNameY="totalSales.seriesNameY"
        width="100%"
      />
    </div>
  </div>
</template>

<style lang="scss">
@import "@/css/color.scss";

.StatisticsAgent {
  padding-left: 30px;
  padding-top: 15px;

  .cardTitleText {
    font-size: 20px;
    color: rgba(51, 51, 51, 1);
    line-height: 28px;
    margin: 15px 0;
  }

  .gameSearchForm {
    margin: 0px 0px 25px !important;
    color: rgba(89, 94, 122, 1);

    .colStyle {
      padding: 0 !important;
    }

    .targetView {
      float: right;
    }

    .selectInputStyle {
      width: 200px;
    }

    .searchTitle {
      padding-right: 10px;
      display: inline-block;
    }

    .dateSelectTitle {
      padding-bottom: 10px;
      color: rgba(10, 10, 10, 1);
      line-height: 20px;
    }

    .dateRange {
      width: 250px;

      .el-range-editor--mini.el-input__inner {
        height: 32px;
      }

      .el-range-editor.is-active,
      .el-range-editor.is-active:hover {
        border-color: #00c1de;
      }

      .el-date-table td.today span {
        color: #00c1de;
      }
    }

    .filterTab {
      display: inline-block;
      margin-right: 20px;
      font-size: 14px;
      line-height: 20px;
      //   margin-left: -10px;
      padding: 5px 10px;
      border-radius: 4px;
      cursor: pointer;
    }

    .searchButton {
      background-color: #00c1de;
      border-color: #00c1de;
      color: #fff;
      height: 36px;
    }

    .searchLocation {
      float: right;
      display: flex;
      margin-right: 70px;
      margin-top: -20px;

      .line {
        width: 1px;
        height: 40px;
        background-color: #e4e8eb;
        margin-left: 25px;
        margin-right: 25px;
      }

      .saleNumberTitle {
        font-size: 14px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
        line-height: 22px;
      }

      .saleNumber {
        font-size: 20px;
        color: rgba(0, 0, 0, 0.85);
        line-height: 32px;
      }
    }

    .selectDateView {
      float: right;
      display: flex;
      margin-right: 30px;
      margin-top: -20px;

      .timeFilterSelect {
        width: 100px;
      }
    }
  }

  .chartview {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    min-height: 350px;

    .statisticsCharts {
      margin-bottom: 15px;
      margin-top: 15px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/visionStatistics/StatisticsAgent.vue